export default __webpack_public_path__ + "static/media/back.0c94785d.svg";